<div class="container-workers">
  <div class="container-workers__wrapper">
    <div class="header">
      <h1 class="header__title">
        {{ "tachograph" | translate }}
      </h1>

      <p-tabMenu
        #tabMenu
        [model]="TABS"
        [activeItem]="activeItem"
        class="header__tab-menu"
      ></p-tabMenu>
    </div>

    <div class="content">
      <app-tachograph-vehicles-files-status
        *ngIf="activeView() === VIEW.VehiclesStatus"
        (openFiles$)="openFilesDDDWithInitValue($event, VIEW.FilesDDDVehicles)"
      ></app-tachograph-vehicles-files-status>

      <app-tachograph-drivers-files-status
        *ngIf="activeView() === VIEW.DriversStatus"
        (openFiles$)="openFilesDDDWithInitValue($event, VIEW.FilesDDDDriver)"
      ></app-tachograph-drivers-files-status>

      <app-tachograph-files-ddd-vehicles
        *ngIf="activeView() === VIEW.FilesDDDVehicles"
        [initSearchValue]="initalSearchValueFilesDDD"
      ></app-tachograph-files-ddd-vehicles>

      <app-tachograph-files-ddd-drivers
        *ngIf="activeView() === VIEW.FilesDDDDriver"
        [initSearchValue]="initalSearchValueFilesDDD"
      ></app-tachograph-files-ddd-drivers>

      <app-tachograf-config
        *ngIf="activeView() === VIEW.Config"
      ></app-tachograf-config>
    </div>
  </div>
</div>
